// styles
import styles from './media-releases.module.scss';

// components
import { CmsLink } from 'components/Link/CmsLink';

// utils
import { decodingContent } from 'utils/decodingContent';
import { useCurrentLanguage } from 'utils/hooks/useCurrentLanguage';

export interface File {
  name: string;
  url: string;
  filesize?: number;
}

export default function Download({ name, url, filesize = 0 }: Readonly<File>) {
  const lang = useCurrentLanguage();
  const sizeString = (Math.round((filesize || 0) * 100) / 100).toLocaleString(
    lang.replace('_', '-'),
  );

  if (!name || !url) {
    return null;
  }

  return (
    <div>
      <CmsLink
        link={{ target: url, window: '_blank' }}
        standardFontSize={false}
        icon="Pdf"
        alignByContent="left"
        stylingType="primary"
        className={styles.link}
      >
        {decodingContent(name)} ({sizeString} MB)
      </CmsLink>
    </div>
  );
}
